export class SupplierGroup{

    constructor(
        public id: any = 0,
        public groupId: any = '0',
        public groupName: string = ''
    ){

    }
}